const form9 = {
  formId9: "new-user-form9",
  formField9: {
    endow: {
      name: "endow",
      label: "Ưu đãi cùng/ khác địa bàn với nơi có trụ sở chính:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn ưu đãi cùng/ khác địa bàn với nơi có trụ sở chính",
    },
    departmentLevel: {
      name: "departmentLevel",
      label: "Cơ quan thuế cấp Cục:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn cơ quan thuế cấp Cục",
    },
    subordinateToTheDepartment: {
      name: "subordinateToTheDepartment",
      label: "Cơ quan thuế cấp chi Cục:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn cơ quan thuế cấp chi Cục",
    },
    city: {
      name: "city",
      label: "[09C] Tỉnh/ thành phố:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn tỉnh/ thành phố",
    },
    district: {
      name: "district",
      label: "[09B] Quận/ huyện:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn quận/ huyện",
    },
    commune: {
      name: "commune",
      label: "[09C] Xã/ phường:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn xã/ phường",
    },

    endowTNDN: {
      name: "endowTNDN",
      label: "Ưu đãi thuế TNDN dành cho doanh nghiệp thực hiện chuyển giao công nghệ thuộc lĩnh vực ưu tiên chuyển giao cho tổ chức, cá nhân ở địa bàn có điều kiện kinh tế - xã hội đặc biệt khó khăn:",
      type: "text",
    },
    endowKHCN: {
      name: "endowKHCN",
      label: "Ưu đãi thuế TNDN dành cho doanh nghiệp khoa học công nghệ:",
      type: "text",
      
    },
    addressEndow: {
      name: "addressEndow",
      label: "Nơi cấp:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập nơi cấp",
    },
    confirmEndow: {
      name: "confirmEndow",
      label: "1. Số Giấy chứng nhận doanh nghiệp khoa học và công nghệ:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số Giấy chứng nhận doanh nghiệp khoa học và công nghệ",
    },
    dateConfirmEndow: {
      name: "dateConfirmEndow",
      label: "Ngày cấp:",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày",
    },
  },
};

export default form9;
